import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyGlassesAccessories } from "src/app/models/company-glasses-accessories.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })

  export class CompanyDressGlassesAccessoriesService extends BaseService {
  
    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/company-dress-glasses-accessories');
    }

    
  getAccessories() {
    return this.http.get<CompanyGlassesAccessories[]>(`${this.apiUrl}`);
  }

}